"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Checkbox = require("./Checkbox");
Object.keys(_Checkbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Checkbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Checkbox[key];
    }
  });
});
var _CheckboxGroup = require("./CheckboxGroup");
Object.keys(_CheckboxGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CheckboxGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CheckboxGroup[key];
    }
  });
});